import styled from 'styled-components';
import { colors } from './colors';
import { motion } from 'framer-motion';



export const MainButton = styled(motion.button)`
    background: ${colors.primary};
    color: white;
    font-family: "Lato";
    font-weight: 700;
    min-width: 250px;
    padding: 15px 30px;
    border: 0;
    border-radius: 3px;
    outline: none;
    cursor: pointer;
    box-shadow: 0px 10px 20px #0000002B;
`

export const BackButton = styled(MainButton)`
background-color: rgba(255,255,255,0);
color: ${colors.primary};
border: none;
box-shadow: none;
transition: all 0.3s ease-in-out;

:hover{
	text-decoration: underline;
	transform: scale(1.2);
}
`;